import React from "react";
import styles from "./Footer.module.css";
import "../i18n";
import { useTranslation } from 'react-i18next';

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.66 3.27 2 2 0 0 1 3.64 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 5.94 5.94l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.72 16z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
    <path d="M16 11.37a4 4 0 1 1-2.37-2.37" />
    <circle cx="17.5" cy="6.5" r="1" />
  </svg>
);

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isTurkish = i18n.language?.toLowerCase().startsWith("tr");
  const whatsappHref = isTurkish
    ? "https://wa.me/905016566778"
    : "https://wa.me/77072179227";
  const whatsappLabel = isTurkish ? "+90 501 656 6778" : "+7 707 217 9227";
  const instaHref = isTurkish
    ? "https://www.instagram.com/hikaya_tr?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
    : "https://www.instagram.com/hikaya_world?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";
  const instaLabel = isTurkish ? "hikaya_tr" : "hikaya_world";

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <div className={styles.logo}>{t('app.brand')}</div>
          <p className={styles.brandText} dangerouslySetInnerHTML={{ __html: t('footer.brandText').replace('\n','<br/>') }} />
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>{t('footer.contactsTitle')}</h4>
          <a href={whatsappHref} className={styles.link}>
            <PhoneIcon /> {whatsappLabel}
          </a>
          <a href={instaHref} className={styles.link}>
            <InstagramIcon /> {instaLabel}
          </a>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>{t('footer.docsTitle')}</h4>
          <a href="#catalog" className={styles.link}>{t('footer.privacy')}</a>
          <a href="#catalog" className={styles.link}>{t('footer.tos')}</a>
          <a href="#catalog" className={styles.link}>{t('footer.contact_us')}</a>
        </div>
      </div>

      <div className={styles.bottom}>
        <span>{t('footer.copyright')}</span>
        <span>{t('footer.made')}</span>
      </div>
    </footer>
  );
};

export default Footer;
